import React, { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";

import { StorageAddonModalState } from "MVVM/State";
import { EPriceTabView } from "MVVM/@types";
import { usePortal } from "MVVM/Hooks/usePortal";
import { StorageAddonModal } from "./index";

export const GlobalStorageAddonModal = () => {
  const [modalState, setModalState] = useRecoilState(StorageAddonModalState);

  const handleClose = () => {
    setModalState({
      isOpen: false,
      analyticsSource: "",
    });
  };

  const billingPeriod =
    modalState.initialBillingPeriod === "Annual"
      ? EPriceTabView.Annual
      : modalState.initialBillingPeriod === "Monthly"
      ? EPriceTabView.Monthly
      : undefined;

  const { portalOpen, setPortalOpen, Portal } = usePortal(
    <StorageAddonModal
      onClose={handleClose}
      analyticsSource={modalState.analyticsSource}
      initialPlan={modalState.initialPlan}
      initialBillingPeriod={billingPeriod}
    />,
  );

  useEffect(() => {
    if (modalState.isOpen && !portalOpen) {
      setPortalOpen(true);
    }
  }, [modalState.isOpen, portalOpen, setPortalOpen]);

  // Tracks whether the portal has actually opened, so the effect below only
  // reacts to a genuine open→close transition (e.g. usePortal's internal
  // nav-listener auto-closing it) — not the initial render, where portalOpen
  // is still stale-false in the same commit that just flipped isOpen true.
  const hasOpenedPortalRef = useRef(false);
  useEffect(() => {
    if (portalOpen) hasOpenedPortalRef.current = true;
  }, [portalOpen]);

  useEffect(() => {
    if (hasOpenedPortalRef.current && !portalOpen && modalState.isOpen) {
      setModalState({ isOpen: false, analyticsSource: "" });
    }
  }, [portalOpen, modalState.isOpen, setModalState]);

  if (!modalState.isOpen) return null;

  return <>{Portal}</>;
};
